module.exports = __webpack_public_path__ + "img/63.1e61b1a6.png";